import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';

import {
  StockPackingHistoryListContent,
  StockPackingHistorySearchCriteria,
  StockPackingHistoryViewResponse
} from '../model/stock-packing-history.model';

@Injectable({
  providedIn: 'root'
})
export class StockPackingHistoryService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockPackingHistory;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStockPackingHistoryList(criteria: StockPackingHistorySearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.list);
    return this.http.get<Pagination<StockPackingHistoryListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStockPackingHistoryView(recallNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { recallNo });
    return this.http.get<StockPackingHistoryViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getStockPackingHistoryFileUrl(filePath: string) {
    const url = this.getFullNestUrl(this.envService.fileUrl, { filePath });
    return this.http.post<{ signedUrl: string }>(
      url,
      { filePath },
      {
        headers: this.loaderHeaders(null),
        observe: 'body'
      }
    );
  }
}
